<template>
    <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.63672 15H7.5293V2.63672H2.63672V15ZM5.33203 7.93945H6.21094V8.81836H5.33203V7.93945Z" />
        <path d="M9.72656 6.18164H11.4844V0H0V15H1.75781V1.75781H9.72656V6.18164Z" />
        <path d="M9.72656 10.5762H11.4844V15H9.72656V10.5762Z" />
        <path d="M15 8.37891L12.3633 5.74219V7.06055H8.4082V9.69727H12.3633V11.0156L15 8.37891Z" />
    </svg>
</template>
